import { render, staticRenderFns } from "./printerRuleDiv.vue?vue&type=template&id=2dcb5faa&scoped=true"
import script from "./printerRuleDiv.vue?vue&type=script&lang=js"
export * from "./printerRuleDiv.vue?vue&type=script&lang=js"
import style0 from "./printerRuleDiv.vue?vue&type=style&index=0&id=2dcb5faa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcb5faa",
  null
  
)

export default component.exports